import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';
import { DecimalPipe } from '@angular/common';

export interface salesMasterDetDtoParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface salesMasterDetDto { 
    phBillId?: any;
    phMedicineId:string;
    phBatch:string;
    phExpDate:any;
    phSellRate:number;
    phQty:number;
    phSellAmount:number;
    phDiscPercentage:number;
    phDiscAmt:number;
    phDiscountValue:string;
    phDiscountwithAmount:number;
    phGSTPercentage:number;
    phGSTAmount:string;
    phGSTWithAmount:string;
    phNetAmount:number;
    phCostRate:number;
    phCostAmount:number;
    sellPriceStrip:number;
    // phMrpRate:any;
    // phMrpAmount:any;
    PhUnitMrpRate:number;
    PhStripMrpAmount:number;
    branch:string;
    tenant:string;
    tenantId: string;
    branchId: string;    
    
    parameters?: salesMasterDetDtoParameter[];
    links?: any;
}


export abstract class salesMasterDetDtoData {
    // abstract create(url: string,data: salesMasterDetDto): Observable<any>;
}
